export default {
    'SETTINGS.USER.EDIT.POPUP.TITLE': 'Modifier un utilisateur',
    'SETTINGS.USER.ADD.POPUP.TITLE': 'Ajouter un utilisateur',
    'SETTINGS.POPUP.SUCCESS.TITLE': 'Modifications enregistrées',
    'SETTINGS.POPUP.SUCCESS.SUB': 'Les données ont été enregistrées',
};
